import classNames from 'classnames';
import React from 'react';
import './Button.css';

export function Button(props) {
  return (
    <button 
      className={ classNames('button', { 'disabled' : !props.enabled }) }
      onClick={props.onClick}
      disabled={!props.enabled}
    >
      {props.children}
    </button>
  )
}